import * as Yup from 'yup'

import { formValidation } from '../FormLegacy/validation'

export const validationSchema = Yup.object().shape({
  category: formValidation.requiredCategory,
  description: formValidation.required,
  image: formValidation.requiredImage,
  logo: formValidation.requiredImage,
  name: formValidation.required,
  link: Yup.string().when('perkType', {
    is: 'link',
    then: formValidation.required,
    otherwise: Yup.string().nullable(),
  }),
  tag: formValidation.discount,
  url: Yup.string().when('perkType', {
    is: 'url',
    then: formValidation.link,
    otherwise: Yup.string().nullable(),
  }),
})
